import { List } from "./services/List";

const SnippetQuery = {
  records: [`snippets?type=eq.snippet&offset=$from&name=ilike.%$search%&limit=10&order=id.asc`, true],
  aggregation: [`snippets?type=eq.snippet&select=count()&name=ilike.%$search%`, false],
}


export default () => {
  return (
    <List
      mainKey={"name"}
      query={SnippetQuery}
      path="/snippets"
      name="Snippety"
      plural="snipettów"
    />
  );
};
